import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import AnalyzePoint from '../../resource/plugins/AnalyzePoint/index';
Vue.use(AnalyzePoint('global-pay', 'webStore', true));

import { initBiPoint } from '../../resource/plugins/biPoint/index';
initBiPoint({ dataLayerName: 'sdkstoreDataLayer' });

import App from '../../App.vue';
import router from '../rooters/webStore';
import store from '../stores/webStore';
import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';
import globalConfig from '../../resource/utiles/globalConfig';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import touchActive from '../../resource/diractives/touchActive';
import '@plugins/replaceAllPolyfills';
Vue.directive('touchActive', touchActive);
handleStoreDefaultCid();
globalConfig.setPageTitleAndIco('store page');
setCommonPlugins(Vue);
globalConfig.setVuePrototypePlatformConfig(Vue);
Vue.config.productionTip = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#webStore');
